module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#women-home",
      toString: function () {
        return this.url;
      }
    }